import { FunctionComponent, useEffect, useState } from "react";

interface PasswordFieldProps {
  onChangeCallback?: (value: string) => void;
  formwasSubmitted: boolean
}

export const NicknameField: FunctionComponent<PasswordFieldProps> = ( { onChangeCallback,formwasSubmitted } ) => {

    const [nick, setNick] = useState<string>('');
    const [isValid, setIsValid] = useState<boolean|null>(null);

    const regex = /^(?=(?:.*[A-Za-z]){4,})[A-Za-z0-9]{6,32}$/;
    const handleChange = (e:any) => {
        const nick = e.target.value;
        setNick(nick);
        setIsValid(regex.test(nick));
        onChangeCallback?.(nick);
    };

    useEffect ( () => {
        if (!formwasSubmitted) setIsValid(null)
    },[formwasSubmitted])

    return (
        <div className="form-input-wrapper">
            <label htmlFor="">Apelido <small>(Entre 6 e 32, só letras/números, mín. 4 letras)</small></label>
            <input type="text"
                className={`bottomPad ${
                    isValid === null
                        ? "border-gray"
                        : isValid
                        ? "border-green"
                        : "border-red"
                    }`}
                value={nick}
                onChange={handleChange} />
            {isValid === false && (
                <p className="text-danger">
                    Entrada inválida: 6–32 caracteres, mínimo 4 letras, sem espaços ou especiais.
                </p>
            )}
            {isValid === true && (
                <p className="text-success">
                    Apelido correto
                </p>
            )}
        </div>
    )
}                        
                        
                        
